<script setup lang="ts">
import type { InvoiceStatus } from "#imports"
defineProps<{
  status: InvoiceStatus
  is_only_credit_note: boolean
  is_accounted: boolean
}>()
</script>

<template>
  <Badge :color="mapInvoiceStatusColor[status]">
    <div class="inline-flex max-w-full items-center justify-center gap-x-1">
      <p v-overflow class="max-w-full truncate">
        {{ $t(`invoice.status.${status}`).toLowerCase() }}
      </p>
      <UIcon
        v-if="is_accounted"
        name="i-ri-loader-2-line"
        class="size-4 shrink-0 text-yellow-600"
      />
    </div>
  </Badge>
</template>
